import { required } from '@rxweb/reactive-form-validators';

export class categoryModel {
    @required()
    name: string;

    @required()
    description: string;

}
